import { NgClass } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Button } from 'primeng/button';
import { Menu } from 'primeng/menu';

import { SolicitudPendiente } from '../../../../shared/interfaces/chat.interface';
import {
  SOLICITUD_BANNER,
  SolicitudAccion,
  SolicitudBannerAccion,
} from '../../solicitudes.model';

@Component({
  selector: 'app-solicitud-banner',
  standalone: true,
  imports: [NgClass, Button, Menu],
  templateUrl: './solicitud-banner.component.html',
  styleUrl: './solicitud-banner.component.scss',
})
export class SolicitudBannerComponent {
  readonly solicitud = input.required<SolicitudPendiente>();
  /** "al Muelle" solo tiene sentido si la persona todavia tiene celula. */
  readonly puedeAlMuelle = input(false);

  readonly accion = output<SolicitudBannerAccion>();

  readonly copy = computed(() => SOLICITUD_BANNER[this.solicitud().tipo]);

  readonly esEliminar = computed(() => this.solicitud().tipo === 'eliminar');

  readonly menuItems = computed<MenuItem[]>(() => {
    if (!this.esEliminar()) {
      return [
        { label: 'Aceptar', icon: 'pi pi-check', command: () => this.emitir('aceptar') },
        { label: 'Cancelar', icon: 'pi pi-times', command: () => this.emitir('rechazar') },
      ];
    }

    const items: MenuItem[] = [
      { label: 'Eliminar', icon: 'pi pi-trash', command: () => this.emitir('eliminar') },
    ];

    if (this.puedeAlMuelle()) {
      items.push({ label: 'al Muelle', icon: 'pi pi-inbox', command: () => this.emitir('muelle') });
    }

    items.push({ label: 'Cancelar', icon: 'pi pi-times', command: () => this.emitir('rechazar') });

    return items;
  });

  private emitir(accion: SolicitudAccion): void {
    this.accion.emit({ tipo: this.solicitud().tipo, accion });
  }
}
